import styles from "./About.module.scss";
import Photo from "../../assets/images/about/about_anime_laptop.webp";

export const About = () => {
  const {
    section__about,
    wrapper__about,
    about__leftSide,
    about__rightSide,
    about__photo,
  } = styles;

  return (
    <section className={section__about} id="about">
      <div className={wrapper__about}>
        <div className={about__leftSide}>
          <div className={about__photo}>
            <img data-aos="zoom-in" data-aos-duration="2000" src={Photo} alt="my_photo" />
          </div>
          <p data-aos="fade-up"  data-aos-delay="300">
            Posiadam ponad trzy letnie doświadczenie w tworzeniu stron
            internetowych dla firm i prywatnych osób.
          </p>
          {/* <p data-aos="fade-up" data-aos-delay="400">Specjalizuję się w tworzeniu stron internetowych dla małych i średnich firm.</p> */}
          {/* <p data-aos="fade-up" data-aos-delay="500">
            Twoja strona stanie się skutecznym narzędziem w marketingu dla firm, przyciągającym nowych odbiorców i wspierającym rozwój Twojego biznesu, dzięki optymalizacji pod kątem wyników wyszukiwania w Google.
          </p> */}
        </div>
        <div className={about__rightSide}>
          <h2 data-aos="fade-up" data-aos-delay="200">Profesjonalne strony internetowe dla firm</h2>
          <h3 data-aos="fade-up" data-aos-delay="250">Zyskaj przewagę na rynku!</h3>
          {/* <p data-aos="fade-up"  data-aos-delay="300">
            Posiadam ponad trzy letnie doświadczenie w tworzeniu stron
            internetowych dla firm i prywatnych osób.
          </p> */}
          <p data-aos="fade-up" data-aos-delay="500">
            Twoja strona stanie się skutecznym narzędziem w marketingu dla firm, przyciągającym nowych odbiorców i wspierającym rozwój Twojego biznesu, dzięki optymalizacji pod kątem wyników wyszukiwania w Google.
          </p>
          <p data-aos="fade-up" data-aos-delay="400">Specjalizuję się w tworzeniu stron internetowych dla małych i średnich firm.</p>

        </div>
      </div>
    </section>
  );
};
